import React from "react";
import { intComma } from "humanize-plus";
import * as time from "../../utils/time";
import { HeadCell } from "../../components/table/sortableTable";

export const headCells: HeadCell[] = [
    {
        label: "年月",
        id: "year_month",
        align: "right",
        headerAlignRight: false,
        numeric: false,
        format: (x, row: Row) => {
            let unfixed = "";
            if (!row.fixed) {
                unfixed = "(未確定)";
            }
            return time.yearmonth(x) + unfixed;
        },
        grow: 3,
    },
    {
        label: "営業所",
        id: "office_name",
        numeric: false,
        grow: 4,
    },
    {
        label: "請求金額(税抜)",
        id: "payment_amount",
        headerAlignRight: true,
        numeric: true,
        align: "right",
        grow: 2,
        format: (r) => {
            return intComma(r);
        },
    },
    {
        label: "対象乗務員数",
        id: "nr_chargeable_drivers",
        headerAlignRight: true,
        numeric: true,
        align: "right",
        format: (r) => {
            return intComma(r);
        },
    },
    {
        label: "課金対象実車数",
        id: "nr_chargeable_trips",
        headerAlignRight: true,
        numeric: true,
        align: "right",
        format: (r) => {
            return intComma(r);
        },
        grow: 1,
    },
    {
        label: "",
        id: "link_driver_page",
        numeric: false,
        grow: 5,
    },
];

export type Row = {
    year_month: number;
    payment_amount: number;
    office_name: string;
    nr_chargeable_drivers: number;
    nr_chargeable_trips: number;
    fixed: boolean;
    link_driver_page: JSX.Element;
    row_id: string;
};
